import { absolutePath } from "./absolutePath";

interface CommunityMemberChargeFnProps {
  chargeId?: string | number;
  params?: Record<string, unknown>;
  processorId?: string | number;
}

export const communityMemberCharge = {
  show: ({ processorId }: CommunityMemberChargeFnProps) =>
    absolutePath(`community_member_charges/${processorId}`),
  index: ({ params = {} }: CommunityMemberChargeFnProps = {}) =>
    absolutePath("community_member_charges", params),
  invoice: {
    show: ({ chargeId }: CommunityMemberChargeFnProps) =>
      absolutePath(`community_member_charges/invoices/${chargeId}`),
  },
};
